import React, { FC } from 'react';
import { useArticleById } from '@/features/wordpress/hooks/useArticleById';
import style from './styles.module.css';

export const MediaList: FC = () => {
  const { article: articles } = useArticleById(10368);
  console.log(articles);
  return (
    <div>
      <div className="text-center mt-4">{articles?.title.rendered}</div>
      <div
        className={style.media_list}
        dangerouslySetInnerHTML={{ __html: articles?.content.rendered }}
      />
    </div>
  );
};
